import { useEffect } from 'react';

import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';
import { goToHomePageWithReload, reloadPage } from '../../../utils/windowUtils';

export const useTabSynchronization = () => {
  const checkLoggedUser = (event: StorageEvent) => {
    const isValueChanged = event.newValue !== event.oldValue;
    const isUserLoggedIn =
      event.key === LOCAL_STORAGE_KEYS.LOGGED_IN_USER && isValueChanged;
    const isClearedStorage = !event.key;

    const isActiveSolutionChanged =
      event.key === LOCAL_STORAGE_KEYS.ACTIVE_SOLUTION && isValueChanged;

    if (isUserLoggedIn || isClearedStorage) {
      reloadPage();
    }

    if (isActiveSolutionChanged) {
      goToHomePageWithReload();
    }
  };

  useEffect(() => {
    window.addEventListener('storage', checkLoggedUser);
    return () => {
      window.removeEventListener('storage', checkLoggedUser);
    };
  });
};
